import { render, staticRenderFns } from "./CourseToBeReviewed.vue?vue&type=template&id=7ebefb00"
import script from "./CourseToBeReviewed.vue?vue&type=script&lang=js"
export * from "./CourseToBeReviewed.vue?vue&type=script&lang=js"
import style0 from "./CourseToBeReviewed.vue?vue&type=style&index=0&id=7ebefb00&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports